import script from "./AlertsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlertsView.vue?vue&type=script&setup=true&lang=ts"

import "./AlertsView.vue?vue&type=style&index=0&id=4ec4692b&lang=scss"

const __exports__ = script;

export default __exports__